import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { useDebounce } from 'use-debounce';
import { useIsMounted } from '../../hooks/use_is_mounted.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var FetchDropdownItems = function FetchDropdownItems(_ref) {
  var fetchResults = _ref.fetchResults,
      _ref$inputText = _ref.inputText,
      inputText = _ref$inputText === void 0 ? "" : _ref$inputText,
      onLoaded = _ref.onLoaded,
      render = _ref.render;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      error = _React$useState4[0],
      setError = _React$useState4[1];

  var _React$useState5 = React.useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      items = _React$useState6[0],
      setItems = _React$useState6[1];

  var _useThemeContext = useThemeContext(),
      i18n = _useThemeContext.i18n;

  var _i18n$Search = i18n.Search,
      showSearchResults = _i18n$Search.showSearchResults,
      searching = _i18n$Search.searching;
  var isMounted = useIsMounted();

  var _useDebounce = useDebounce(inputText, 400),
      _useDebounce2 = _slicedToArray(_useDebounce, 1),
      debouncedInputText = _useDebounce2[0];

  React.useEffect(function () {
    if (debouncedInputText) {
      var isCurrent = true;
      setLoading(true);
      fetchResults(debouncedInputText).then(function (fetchedItems) {
        if (isMounted.current && isCurrent) {
          setLoading(false);
          setItems(fetchedItems);
          onLoaded();
        }
      }).catch(function () {
        setLoading(false);
        setItems([]);
        setError(true);
      });
      return function () {
        isCurrent = false;
      };
    } else {
      setLoading(false);
      setItems([]);
    }
  }, [debouncedInputText, isMounted]);
  var searchResultsLabel = items.length ? showSearchResults : "";
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx(VisuallyHidden, {
      role: "region",
      "aria-live": "polite",
      children: loading ? searching : searchResultsLabel
    }), render({
      loading: loading,
      error: error,
      dropdownItems: items
    })]
  });
};

FetchDropdownItems.propTypes = {
  "fetchResults": _PropTypes.func.isRequired,
  "inputText": _PropTypes.string,
  "onLoaded": _PropTypes.func.isRequired,
  "render": _PropTypes.func.isRequired
};
FetchDropdownItems.displayName = "FetchDropdownItems";

export { FetchDropdownItems };
